export class BacktestingService {
  static runBacktest(_config: any) {
    return { trades: [], profit: 0, winRate: 0 };
  }
}
